import React, { useState } from 'react';
import cx from '../../../../styles';
import { Icon } from '../../../Common/Icon';
import {gtmSend} from '../../../../helpers';

const StarRating = (props) => {
    const [rating, setRating] = useState(props.rating);
    const storeStar = (poll,star) => {
        if(!props.isRatingDisabled) {
            setRating(star);
            props.storeRating(poll, star);
        }
    }
    return (
        <div className={cx('star-rating')}>
                {
                    props.pollChoices.map((poll,index) => {
                        return(
                            <div key={index} onClick={ () => {storeStar(poll, index+1)}}>
                                <Icon name='star-poll-unfilled' className={rating >= index +1 ? 'svg-fill' : ''}/>
                            </div>
                        )
                    })
                }
        </div>
    )
}

export const RatingPrePoll = ({pollChoices, voteHandler, match,t}) => {
    const [poll, setPoll] = useState({});

    const storeRating = (poll) => {
        setPoll(poll);
    }

    return (
        <div className={cx('pre-poll-state','rating')}> 
            <StarRating storeRating={storeRating} isRatingDisabled={false} pollChoices={pollChoices} rating={0}/>
            <button className={cx("btn")} onClick={() => {voteHandler(poll.poll_id, poll.id) ;gtmSend('dynamic', 'Poll Card', 'click-submit-rating', match.path)}}> {t("submit_vote")}</button>
        </div>
    );
}

export const RatingPostPoll = ({votes}) => {

    let responseRating ;
    votes.map((vote,index) => {
        if(vote.user_choice === 1){
            responseRating = index + 1;
        }
        return false
    })
    return (
        <div className={cx('post-poll-state','rating')}>
             <StarRating isRatingDisabled={true} pollChoices={votes} rating={responseRating}/>
        </div>
    );
}
